export * from './notification-mutation-resolve.interface';
export * from './notification-mutation-resolve.service';
export * from './notification-mutation-resolve.mock';
export const NOTIFICATION_MUTATION_RESOLVE_SERVICE = Symbol('NotificationMutationResolveService');
